var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraftProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2992 18.2V15.8H32.1992C32.0992 15.5 31.9992 15.3 31.8992 15.1L33.3992 13.6L31.6992 11.9L30.1992 13.4C29.9992 13.3 29.6992 13.2 29.4992 13.1V11H26.9992V13C26.6992 13.1 26.4992 13.2 26.2992 13.3L24.7992 11.8L23.0992 13.5L24.5992 15C24.4992 15.2 24.3992 15.5 24.2992 15.7H22.1992V18.1H24.2992C24.3992 18.4 24.4992 18.6 24.5992 18.8L23.0992 20.3L24.7992 22L26.2992 20.5C26.4992 20.6 26.7992 20.7 26.9992 20.8V23H29.3992V21C29.6992 20.9 29.8992 20.8 30.0992 20.7L31.5992 22.2L33.2992 20.5L31.8992 19C31.9992 18.8 32.0992 18.5 32.1992 18.3H34.2992V18.2ZM29.9992 17C29.9992 17.5 29.7992 17.9 29.4992 18.2C29.1992 18.5 28.7992 18.7 28.2992 18.7H28.1992C27.6992 18.7 27.2992 18.5 26.9992 18.2C26.6992 17.9 26.4992 17.5 26.4992 17C26.4992 16.5 26.6992 16.1 26.9992 15.8C27.2992 15.5 27.6992 15.3 28.1992 15.3H28.2992C28.7992 15.3 29.1992 15.5 29.4992 15.8C29.7992 16.1 29.9992 16.5 29.9992 17Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 13.1C14.1996 13.1 11.0996 16.2 11.0996 20C11.0996 23.8 14.1996 26.9 17.9996 26.9C21.7996 26.9 24.8996 23.8 24.8996 20C24.8996 16.2 21.7996 13.1 17.9996 13.1ZM17.9996 24.7C15.3996 24.7 13.3996 22.6 13.3996 20.1C13.3996 17.5 15.4996 15.5 17.9996 15.5C20.5996 15.5 22.5996 17.6 22.5996 20.1C22.5996 22.6 20.5996 24.7 17.9996 24.7Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9996 20.1H9.09961V25.6H26.9996V20.1Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9996 25.5H9.09961V31.9H26.9996V25.5Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24H16V28H20V24Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80039 7.1L3.90039 8.5L10.1004 13L10.8004 10.7C11.2004 9.3 10.8004 7.9 9.60039 7C8.50039 6.3 7.00039 6.3 5.80039 7.1Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30039 7.1L8.20039 8.5L2.00039 13L1.30039 10.7C0.900391 9.3 1.30039 7.9 2.50039 7C3.60039 6.3 5.20039 6.3 6.30039 7.1Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10069 1.10001C3.10069 3.40001 2.10069 7.50001 3.80069 10.9L4.00069 11.4H8.20069L8.50069 10.9C10.1007 7.50001 9.10069 3.40001 6.10069 1.10001Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 13.5V21",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 13.5V18.6",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09961 13.5V18.6",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9 3.3C13.6 1.8 16.7 1 20 1C30.5 1 39 9.5 39 20C39 30.5 30.5 39 20 39C9.5 39 1 30.5 1 20C1 18.6 1.2 17.1 1.5 15.8",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftProject);
export default __webpack_public_path__ + "static/media/draft-project.526e97a970495e54853e3c0c155d1422.svg";
export { ForwardRef as ReactComponent };